module.exports = {"searchMenu":"Search menu","recentSearch":"Recent searches","searchResultCount":"{count} results","noData":"No data","searchShortcut":"Search ({shortcut})"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/en-US/header.json
// module id = /PwN
// module chunks = 1